// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1ndwA","buttons":"PendingPaymentAlert_buttons__37KBg"};